var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { BillingService } from './billing.service';
import { GET_BILLING_INFORMATION, GetBillingInformationFailureAction, GetBillingInformationSuccessAction, UPDATE_BILLING_INFORMATION, UpdateBillingInformationFailureAction, UpdateBillingInformationSuccessAction } from './billing.action';
var BillingEffects = /** @class */ (function () {
    function BillingEffects(actions$, billingService) {
        var _this = this;
        this.actions$ = actions$;
        this.billingService = billingService;
        this.getBillingInformation$ = this.actions$.pipe(ofType(GET_BILLING_INFORMATION), switchMap(function () {
            return _this.billingService
                .getBillingInformation()
                .pipe(map(function (response) { return new GetBillingInformationSuccessAction(response); }), catchError(function (error) { return of(new GetBillingInformationFailureAction(error)); }));
        }));
        this.updateBillingInformation$ = this.actions$.pipe(ofType(UPDATE_BILLING_INFORMATION), map(function (action) { return action.payload; }), switchMap(function (payload) {
            return _this.billingService
                .updateBillingInformation(payload)
                .pipe(map(function () { return new UpdateBillingInformationSuccessAction(payload); }), catchError(function (error) { return of(new UpdateBillingInformationFailureAction(error)); }));
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BillingEffects.prototype, "getBillingInformation$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], BillingEffects.prototype, "updateBillingInformation$", void 0);
    return BillingEffects;
}());
export { BillingEffects };
